import {
  HomeIcon,
  Squares2X2Icon,
  MagnifyingGlassCircleIcon,
  PuzzlePieceIcon,
  ShoppingCartIcon,
  UserCircleIcon,
} from '@heroicons/react/24/outline';

export const createMobileNavItems = ({
  cartCount = 0,
  isAuthenticated = false,
  overrides = {},
} = {}) => {
  const baseItems = [
    { id: 'home', label: 'Home', icon: HomeIcon, href: '/mobile' },
    { id: 'shop', label: 'Shop', icon: Squares2X2Icon, href: '/mobile/makes' },
    { id: 'finder', label: 'Finder', icon: MagnifyingGlassCircleIcon, href: '/mobile/parts-finder' },
    { id: 'accessories', label: 'Accessories', icon: PuzzlePieceIcon, href: '/mobile/accessories-supplies' },
    { id: 'cart', label: 'Cart', icon: ShoppingCartIcon, href: '/mobile/cart', badge: cartCount },
    { id: 'accounts', label: 'Accounts', icon: UserCircleIcon, href: '/mobile/accounts' },
  ];

  return baseItems.map((item) => ({
    ...item,
    ...(overrides[item.id] || {}),
  }));
};
